// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bQbIm","center":"styles_center__iWw4T"};